import React from 'react';
import { connect } from 'react-redux';
import { Route } from 'react-router-dom';
import { ConnectedSwitch } from "./util/ConnectedSwitch";
import { App } from './App';
import {ProgressIndicator} from "./components/modal/ProgressIndicator";

class RootContainer extends React.Component {

  render() {

    const content = this.props.resolve_initial_status
      ? (
          <ConnectedSwitch>
            <Route path='/:lang([a-z]{2})' component={App}/>
          </ConnectedSwitch>
        )
      : (
          /* Rendered on initial browser load */
          <ProgressIndicator/>
        );

    return (
      <div>{ content }</div>
    );
  }
}

export const Root = connect(
  state => ({
    resolve_initial_status: state.resolve.initial_status
  })
)(RootContainer);



// WEBPACK FOOTER //
// ./src/Root.js